export default "__VITE_ASSET__ADo2PlgY__"